<template>
  <v-container class="favourites">
    <v-list>
      <v-app-bar light app color="white">
        <BackButton backTarget="/persons"/>
        <v-toolbar-title>Your favourites</v-toolbar-title>
      </v-app-bar>

      <v-row
          align="center"
          justify="center"
          class="pb-8"
          v-if="images.length === 0">
          <h4 class="subtitle font-weight-regular text-center">
            You did not favourite any image yet.
          </h4>
      </v-row>

      <template v-for="(item) in images">
        <v-list-item
          :key="item.id"
          :to="'/image/' + item.id"
          style="padding: 0px;">

        <ImagePreview :imageItem="item"/>

        </v-list-item>
      </template>
    </v-list>
  </v-container>
</template>

<script>
// @ is an alias to /src
import BackButton from '@/components/BackButton.vue'
import ImagePreview from '@/components/ImagePreview.vue'

export default {
  name: 'favourites',
  components: {
    BackButton,
    ImagePreview,
  },
  data() {
    return {
      appState: this.$root.$data.appStore.state,
      auth: this.$root.$data.auth,
      db: this.$root.$data.db,
      isLoading: true,
      images: [],
    };
  },
  computed: {
    imagesQuery: function () {
      return this.appState.user.uid && this.db.collection('image').where('owner', '==', this.appState.user.uid).where('favouritedAt', '!=', null).orderBy('favouritedAt', 'desc');
    },
  },
  methods: {
    async loadImages() {
      this.loading = true;

      let imagesSnapshot;
      try {
        imagesSnapshot = await this.imagesQuery.get();
      } catch (error) {
        console.log(`Error fetching favourites: ${error}`);
        this.loading = false;
        return;
      }

      let images = [];
      imagesSnapshot.forEach((doc) => {
        images.push({
          id: doc.id,
          personId: doc.data().personId,
          url: doc.data().url,
          websiteUrl: doc.data().websiteUrl,
          favouritedAt: doc.data().favouritedAt,
          priority: doc.data().priority,
        });
      });
      this.images = images;
      this.loading = false;
    }
  },
  mounted() {
    this.loadImages();
  }
}
</script>
